import React from 'react';

import AuthContainer from '../../modules/auth/containers/Auth';
import withUnAuth from './withUnAuth';
import ForgotPasswordForm from '../Forms/Auth/ForgotPassword';

const ForgotPasswordPage = () => {
  return (
    <div className="ForgotPasswordPage">
      <ForgotPasswordForm />
    </div>
  );
};

export default withUnAuth(AuthContainer(ForgotPasswordPage));
